import React from 'react';
import {
  useActiveMarketId,
  useIsFreemiumV3Customer,
} from '../../../hooks/api/metadata';
import {useMarketFromContext} from '../MarketProvider';
import {Box, Flex, HStack, Tag} from '@chakra-ui/react';
import {MarketBuilderTabs} from './MarketBuilderTabs';
import {PublishButton} from './PublishButton';
import {SaveButton} from './SaveButton';
import {RevertButton} from './RevertButton';
import {AccountScorePreviewButton} from './AccountScorePreviewButton';
import {EditableMarketLabel} from './EditableMarketLabel';

export const MarketBuilderHeader = () => {
  const market = useMarketFromContext();
  const activeMarketId = useActiveMarketId();
  const isFreemiumV3 = useIsFreemiumV3Customer();

  return (
    <Flex
      alignItems="center"
      borderBottom="1px solid"
      borderColor="kgray.200"
      justifyContent="space-between"
      py="6"
    >
      <Flex alignItems="center" gap="4" maxW="25%" px={6}>
        <EditableMarketLabel fontSize="2xl" />

        {activeMarketId.equals(market.id) && (
          <Tag
            key="default"
            py="1"
            flexShrink={0}
            size="sm"
            textTransform="uppercase"
          >
            Active
          </Tag>
        )}
      </Flex>

      <Box flex={1}>
        <MarketBuilderTabs />
      </Box>

      <HStack pr={6} spacing={2}>
        <RevertButton />
        <SaveButton />
        <PublishButton />
        {!isFreemiumV3 && <AccountScorePreviewButton />}
      </HStack>
    </Flex>
  );
};
